import {useEffect} from "react";

import {controllerChecklist} from "../../../../services/controllers/service-activation";

import {Header} from "./header";
import {Manual} from "./manual";

export function Checklist(){
  const CLChecklist = controllerChecklist()

  useEffect(()=>{
    CLChecklist.getChecklistConfig()
  },[])


  return(
      <div className="flex flex-col gap-6 w-full">
        <Header />
        <Manual />
      </div>
  )
}
